import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select, { components } from 'react-select';

import '../../styles/contacts.scss';
import { Col, Form, Row } from 'react-bootstrap-5';

const customOptions = (innerProps) => {
  return (
    <components.Option className="select-dropdown" {...innerProps}>
      <div value={innerProps.data.value}>
        <img
          className="dropdown-bubble ms-2 me-3"
          src={innerProps.data.dataPhoto}
          value={innerProps.data.value}
        />
        <span className="ms-3" value={innerProps.data.value}> {innerProps.data.label} </span>
      </div>
    </components.Option>
  );
};

export default class FollowUpTaskForm extends React.Component {

  static propTypes = {
    associateToCallList: PropTypes.bool,
    callListId: PropTypes.number,
    databaseMembers: PropTypes.array.isRequired,
    defaultTaskAssignee: PropTypes.object,
    followUpTask: PropTypes.object.isRequired,
    onTaskChange: PropTypes.func.isRequired,
    onToggleCallList: PropTypes.func
  }

  handleTaskDateChange = e => this.props.onTaskChange(e.target.value, 'dueDate')
  handleTaskTypeSelect = e => this.props.onTaskChange(parseInt(e.target.value), 'taskType')
  handleMemberSelect = e => this.props.onTaskChange(parseInt(e.value), 'assigneeId');

  assigneeOptions = () => {
    const options = this.props.databaseMembers || [];
    return options.map((u) => {
      return {
        value: u.id,
        label: u.name,
        dataPhoto: u.dataPhoto
      };
    });
  }

  render() {
    const {
      associateToCallList,
      callListId,
      followUpTask,
      onToggleCallList
    } = this.props;

    return (
      <div>
        <Row className="mb-2 d-flex align-items-center g-2">
          {this.renderTaskTypes()}
          {this.renderDateSelect()}
        </Row>
        {this.renderAssigneeSelectDropdown()}
        {(callListId && followUpTask.taskType === 1) &&
          <div className="mt-2">
            <Form.Check
              checked={associateToCallList}
              inline
              label="Add to current Call List"
              name="association-check"
              type="checkbox"
              onClick={onToggleCallList}
            />
          </div>
        }
      </div>
    );
  }

  renderDateSelect() {
    const { followUpTask } = this.props;
    const startOfDay = moment().startOf('day');
    return (
      <Col xs={6}>
        <select
          className="form-select"
          defaultValue={startOfDay.clone().add(1, 'days').toString()}
          id="dueDate"
          value={followUpTask.dueDate}
          onChange={this.handleTaskDateChange}
        >
          <option value={startOfDay.clone().add(1, 'days').toString()}>Tomorrow</option>
          <option value={startOfDay.clone().add(2, 'days').toString()}>2 Days</option>
          <option value={startOfDay.clone().add(1, 'weeks').toString()}>1 Week</option>
          <option value={startOfDay.clone().add(2, 'weeks').toString()}>2 Weeks</option>
          <option value={startOfDay.clone().add(1, 'months').toString()}>1 Month</option>
          <option value={startOfDay.clone().add(6, 'months').toString()}>6 Months</option>
          <option value={startOfDay.clone().add(1, 'years').toString()}>1 Year</option>
        </select>
      </Col>
    );
  }

  renderTaskTypes() {
    const { followUpTask } = this.props;
    return (
      <Col xs={6}>
        <select
          className="form-select"
          defaultValue={1}
          id="taskType"
          value={followUpTask.taskType}
          onChange={this.handleTaskTypeSelect}
        >
          <option value={1}>Call</option>
          <option value={2}>Email</option>
          <option value={4}>Todo</option>
        </select>
      </Col>
    );
  }

  renderAssigneeSelectDropdown() {
    const { defaultTaskAssignee, followUpTask } = this.props;
    const defaultAssigneeOptions = [{
      value: defaultTaskAssignee.id,
      label: defaultTaskAssignee.name
    }];

    const options = this.assigneeOptions();
    const value = options.find(option => option.value === followUpTask.assigneeId);

    return (
      <Select
        className="react-select-container"
        components={{
          Option: customOptions
        }}
        defaultValue={defaultAssigneeOptions}
        options={this.assigneeOptions()}
        placeholder={'Assign Task to User'}
        value={value}
        onChange={this.handleMemberSelect}
      />
    );
  }
}
